// extracted by mini-css-extract-plugin
export default {"container":"Map_container__bhnPI","form_box":"Map_form_box__LaJm5","map_box":"Map_map_box__dX2Le"};